import { Checkbox, Radio } from 'antd';
import parse from 'html-react-parser';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const ConsentSequent = ({
    form,
    lang,
    combinedDragData,
    setCombinedDragData,
}) => {
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragPersonalEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const newItems = reorder(
            combinedDragData,
            result.source.index,
            result.destination.index
        );
        const newData = newItems.map((item, index) => ({
            ...item,
            sequence: index + 1,
        }));
        setCombinedDragData(newData);
        form.setFieldsValue({ consentForms: newData });
    };

    return (
        <DragDropContext onDragEnd={onDragPersonalEnd}>
            <Droppable droppableId="droppable">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        {combinedDragData.map((consent, i) => {
                            return (
                                <Draggable
                                    draggableId={
                                        consent?.consentTxnGroupId
                                            ? consent?.consentTxnGroupId
                                            : consent?.noteId
                                    }
                                    index={i}
                                    key={
                                        consent?.consentTxnGroupId
                                            ? consent?.consentTxnGroupId
                                            : consent?.noteId
                                    }
                                >
                                    {(provided) => (
                                        <div
                                            className="bg-[#F4F6FC] p-4 rounded-lg mb-4 relative flex"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <div className="flex items-center mr-4">
                                                <svg
                                                    width="24"
                                                    height="25"
                                                    viewBox="0 0 24 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        y="0.5"
                                                        width="24"
                                                        height="24"
                                                        rx="3"
                                                        fill="#EEE5FF"
                                                    />
                                                    <g clipPath="url(#clip0_2799_251928)">
                                                        <path
                                                            d="M17.3333 10.5H6.66666V11.8333H17.3333V10.5ZM6.66666 14.5H17.3333V13.1667H6.66666V14.5Z"
                                                            fill="#7B67FB"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_2799_251928">
                                                            <rect
                                                                width="16"
                                                                height="16"
                                                                fill="white"
                                                                transform="translate(4 4.5)"
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            <div>
                                                {consent?.type === 'Consent' ? (
                                                    <>
                                                        <div className="text-tiny font-semibold mb-2">
                                                            {lang === 'th'
                                                                ? consent?.consentNameTh
                                                                : consent?.consentNameEn}
                                                        </div>
                                                        <div>
                                                            {parse(
                                                                `${
                                                                    lang ===
                                                                    'th'
                                                                        ? consent?.purposeTh
                                                                        : consent?.purposeEn ??
                                                                          '-'
                                                                }`
                                                            )}
                                                        </div>
                                                        {!consent?.isConsented ? (
                                                            <div>
                                                                <Radio.Group className="flex items-center space-x-4">
                                                                    <div className="bg-white px-4 py-2 rounded-md">
                                                                        <Radio
                                                                            value={
                                                                                1
                                                                            }
                                                                        >
                                                                            {lang ===
                                                                            'en'
                                                                                ? 'I agree'
                                                                                : 'ยินยอม'}
                                                                        </Radio>
                                                                    </div>
                                                                    <div className="bg-white px-4 py-2 rounded-md">
                                                                        <Radio
                                                                            value={
                                                                                2
                                                                            }
                                                                        >
                                                                            {lang ===
                                                                            'en'
                                                                                ? 'Decline'
                                                                                : 'ไม่ยินยอม'}
                                                                        </Radio>
                                                                    </div>
                                                                </Radio.Group>
                                                            </div>
                                                        ) : (
                                                            <div className="bg-white px-4 py-2 rounded-md w-max">
                                                                <Checkbox>
                                                                    {lang ===
                                                                    'en'
                                                                        ? 'Acknowledge'
                                                                        : 'รับทราบ'}
                                                                </Checkbox>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div>
                                                        {parse(
                                                            `${
                                                                lang === 'th'
                                                                    ? consent?.titleTh
                                                                    : consent?.titleEn ??
                                                                      '-'
                                                            }`
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            );
                        })}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default ConsentSequent;
